export default __webpack_public_path__ + "fonts/info-gray.svg";